<template>
  <v-row align="center" justify="space-around">
    <v-col cols="5" sm="5">
      <v-btn
        large
        @click="select('today')"
        v-bind:color="
          Selected === 'today' ? 'buttonSelected' : 'buttonUnselected'
        "
      >
        {{ Today }}
      </v-btn>
    </v-col>
    <v-col cols="5" sm="5">
      <v-btn
        large
        @click="select('tomorrow')"
        v-bind:color="
          Selected === 'tomorrow' ? 'buttonSelected' : 'buttonUnselected'
        "
      >
        {{ Tomorrow }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { helsinkiDay, weekdayName } from "../helsinkiDate";

export default {
  name: "Buttons",
  data() {
    return {
      Today: "",
      Tomorrow: "",
      Selected: "today",
      weekday: null,
    };
  },
  methods: {
    // The labels are derived, never stored, so they go stale in a tab that was
    // left open — or frozen by the OS — past midnight. lunchTables calls this
    // again whenever the page comes back into view. Returns true when the
    // weekday actually rolled, so the caller knows to reload.
    refreshLabels() {
      const today = helsinkiDay(0);
      this.Today = weekdayName(today);
      this.Tomorrow = weekdayName(helsinkiDay(1));

      const weekday = today.getUTCDay();
      const rolled = this.weekday !== null && this.weekday !== weekday;
      this.weekday = weekday;

      if (rolled) {
        // "Tomorrow" now means a different day than the one on screen, so
        // keeping the old selection highlighted would mislabel the refetch.
        this.Selected = "today";
      }
      return rolled;
    },
    select(selection) {
      this.Selected = selection;
      this.$emit(selection);
    },
  },
  mounted() {
    this.refreshLabels();
  },
};
</script>


<style scoped>
button {
  width: 100%;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
</style>
